import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Tab extends Component {
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  onClick = () => {
    const { label, onClick } = this.props;
    onClick(label);
  }

  render() {
    const {
      onClick,
      props: {
        activeTab,
        label,
      },
    } = this;

    let className = 'tabs__item';

    if (activeTab === label) {
      className += ' tabs__item--active';
    }

    return (
      <h4
        className={className}
        onClick={onClick}
      >
        {label}
      </h4>
    );
  }
}

export default Tab;
